import { MouseEventHandler, ReactNode, useCallback } from 'react';
import { useToggle } from 'react-use';

import { HealthcareFacilityLocationSimple } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { TranslatableText } from '@dreryk/react-common';
import { TestableComponentProps } from '@dreryk/react-components';

import { HealthcareBasicData } from '../../../common/HealthcareBasicData';
import { HealthcareTreeItemUpdateLink } from '../HealthcareTreeItemUpdateLink';

import { HealthcareFacilityLocationUpdateModal } from './HealthcareFacilityLocationUpdateModal';

type HealthcareFacilityLocationUpdateLinkProps = TestableComponentProps & {
   readonly healthcareFacilityLocationId: HealthcareFacilityLocationSimple['id'];
   readonly healthcareParentData: HealthcareBasicData;
   readonly onDataChanged: VoidFunction;
   readonly label?: TranslatableText;
   readonly icon?: ReactNode;
};

export const HealthcareFacilityLocationUpdateLink = (props: HealthcareFacilityLocationUpdateLinkProps): JSX.Element => {
   const [showUpdateModal, toggleShowUpdateModal] = useToggle(false);

   const handleUpdateClick = useCallback<MouseEventHandler<HTMLAnchorElement>>(
      (event) => {
         event.preventDefault();
         toggleShowUpdateModal(true);
      },
      [toggleShowUpdateModal]
   );

   const handleDataChanged = useCallback(() => {
      props.onDataChanged();
      toggleShowUpdateModal(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.onDataChanged, toggleShowUpdateModal]);

   return (
      <>
         <HealthcareTreeItemUpdateLink
            icon={props.icon}
            onClick={handleUpdateClick}
            testId={props.testId}
            label={props.label}
         />
         {showUpdateModal ? (
            <HealthcareFacilityLocationUpdateModal
               healthcareFacilityLocationId={props.healthcareFacilityLocationId}
               healthcareParentData={props.healthcareParentData}
               onDataChanged={handleDataChanged}
               onCancel={toggleShowUpdateModal}
            />
         ) : null}
      </>
   );
};
